import React from "react";
import './Slide.css'

function Slide() {
  return (
    <div
      className="slide"
      style={{
        background:
          "#0b7484 url(https://media.istockphoto.com/id/474967306/photo/cute-boy-reading-book-in-library.jpg?b=1&s=170667a&w=0&k=20&c=zkVhrMDjllBBL6AB1zPP1kPOZg3K_pi23L7q9c-FleY=)",
      }}
    >
      <h2>Center For Public Education</h2>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium
        cumque voluptas soluta velit numquam doloribus quisquam vitae saepe
        officia perspiciatis. Facilis repudiandae consequatur omnis libero
        eveniet! Hic facere unde sapiente!
      </p>
    </div>
  );
}

export default Slide;
